import './sl.scss';
import { useTranslation } from 'react-i18next';
import { languages } from '~/i18n';
import { NS } from '~/utils/ns';

export default function SelectLanguage() {
  const { t, i18n } = useTranslation(NS.HEADER);
  const currentLanguage = languages.find((l) => l.code === i18n.language);
  return (
    <div className="cursor-pointer block relative avatar-hover">
      <div className="dropdown switch-language">
        <div className="cursor-pointer flex items-center relative z-40">
          <div className="switch-language__img">
            <img
              src={currentLanguage?.icon}
              alt
              className="switch-language__img-active w-10 h-10"
            />
          </div>
          {/**/}
        </div>
        {/**/}
        {/**/}
      </div>
      <div className="absolute top-[100%] right-[-100px] mobile:right-0 bg-transparent w-[200px] nav-hover-avatar-wrapper z-50">
        <div className="nav-hover-avatar">
          {languages.map((item, index) => {
            return (
              <div
                onClick={() => {
                  i18n.changeLanguage(item.code);
                  window.location.reload();
                }}
                key={index}
                className={` nav-hover-avatar__item flex items-center cursor-pointer !py-0
                    ${item.code === currentLanguage?.code && 'border border-green-500'}`}>
                <img src={item.icon} className="mr-2 w-6 h-6" />
                <span className="whitespace-nowrap text-white text-[13px]">{item.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
